import '../styles/Weather-cards.css';

const WeatherCards = () => {
    return; 
};

export default WeatherCards; 